const data = [
  {
    id: 1,
    title: "Workleisure",
    slug: "workleisure",
    heading: "Workspace Platform",
    image: "images/Workleisure.png",
    category: "Web Development",
  },
  {
    id: 2,
    title: "Wellnivo",
    slug: "wellnivo",
    heading: "Wellness Website",
    image: "images/Wellnivo.png",
    category: "Web Development",
  },
  {
    id: 3,
    title: "Career Mitra",
    slug: "career-mitra",
    heading: "Career Counselling Website",
    image: "images/CareerMitra.png",
    category: "Web Development",
  },
  {
    id: 4,
    title: "Winndo",
    slug: "winndo",
    heading: "E-Commerce Website",
    image: "images/Windo.png",
    category: "Web Development",
  },
  {
    id: 5,
    title: "Mobile Repairing Tools",
    slug: "mobile-repairing-tools",
    heading: "E-Commerce Website",
    image: "images/mobile.png",
    category: "Web Development",
  },
  {
    id: 6,
    title: "HRFS",
    slug: "hrfs",
    heading: "HR Financial Services Website",
    image: "images/hr.png",
    category: "Web Development",
  },
  {
    id: 7,
    title: "Gen AI Chatbot",
    slug: "gen-ai-chatbot",
    heading: "Chatbot Integration",
    image: "images/chatbot.png",
    category: "AI",
  },
  {
    id: 8,
    title: "Linkedin Automation",
    slug: "linkedin-automation",
    heading: "Lead Generation Tool",
    image: "images/linkedin.png",
    category: "AI",
  },
  {
    id: 9,
    title: "Bounzy",
    slug: "bounzy",
    heading: "Casual Game",
    image: "images/bounzy.png",
    category: "Game Development",
  },
  {
    id: 10,
    title: "Bar Simulator",
    slug: "bar-simulator",
    heading: "Simulation Game",
    image: "images/bar.png",
    category: "Game Development",
  },
  {
    id: 11,
    title: "Evara Furniture AR",
    slug: "evara-furniture-ar",
    heading: "AR Application",
    image: "images/furnar.png",
    category: "AR",
  },
  {
    id: 12,
    title: "Warzone",
    slug: "warzone",
    heading: "FPS Game",
    image: "images/war.png",
    category: "Game Development",
  },
];

export default data;

